import useTranslation from 'next-translate/useTranslation';
import { useContext } from 'react';
import { SETTING_CONTAINERS as SETTING_CONTAINER_NAME } from 'src/interfaces/enums';
import { SettingsOverlayContext } from '../SettingsOverlayContext';
import ResolutionControlContainer from '../components/ResolutionControlContainer';
import PlaybackRateControlContainer from '../components/PlaybackRateControlContainer';
import MainSettingControlContainer from '../components/MainSettingControlContainer';

type SETTING_CONTAINERS_TYPE = {
  [key in SETTING_CONTAINER_NAME]: { component: JSX.Element; title: 'string' };
};

const useSettingsOverlay = () => {
  const { t } = useTranslation('common');
  const { containerName, setContainerName } = useContext(SettingsOverlayContext);

  const SETTING_CONTAINERS: SETTING_CONTAINERS_TYPE = {
    main: {
      component: <MainSettingControlContainer />,
      title: t('settings.main'),
    },
    speed: {
      component: <PlaybackRateControlContainer />,
      title: t('settings.speed'),
    },
    resolution: {
      component: <ResolutionControlContainer />,
      title: t('settings.quality'),
    },
  };

  return {
    containerName,
    setContainerName,
    container: SETTING_CONTAINERS[containerName],
  };
};

export default useSettingsOverlay;
